import { FC } from 'react';

type Props = {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
};

const Email: FC<Props> = ({ width = 19, height = 19, className, color = "#2A1645" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 19 19"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 3.92188H2.75C2.45163 3.92188 2.16548 4.0404 1.9545 4.25138C1.74353 4.46236 1.625 4.74851 1.625 5.04688V14.0469C1.625 14.3452 1.74353 14.6314 1.9545 14.8424C2.16548 15.0533 2.45163 15.1719 2.75 15.1719H16.25C16.5484 15.1719 16.8345 15.0533 17.0455 14.8424C17.2565 14.6314 17.375 14.3452 17.375 14.0469V5.04688C17.375 4.74851 17.2565 4.46236 17.0455 4.25138C16.8345 4.0404 16.5484 3.92188 16.25 3.92188ZM15.0125 5.04688L9.5 8.86062L3.9875 5.04688H15.0125ZM2.75 14.0469V5.55875L9.17938 10.0081C9.27354 10.0734 9.3854 10.1085 9.5 10.1084C9.6146 10.1085 9.72647 10.0734 9.82063 10.0081L16.25 5.55875V14.0469H2.75Z"
        fill={color}
      />
    </svg>
  );
};

export default Email;
